"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiProvider = void 0;
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _swr = require("swr");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _jsxRuntime = require("react/jsx-runtime");
const ApiProvider = ({
  children
}) => {
  const {
    currentLanguage,
    globalApiUrl,
    staticApiUrl,
    tenant
  } = (0, _contexts.useConfiguration)();
  const {
    formattedToken
  } = (0, _auth.useToken)();

  // the initial token value is an empty string
  // this occasionally causes 401 response from the API GW
  if (!formattedToken) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_swr.SWRConfig, {
    value: _constants.swrConfig,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
      baseUrl: globalApiUrl,
      tenant: tenant,
      language: currentLanguage,
      token: formattedToken,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_staticApiClientReact.ApiClientProvider, {
        baseUrl: staticApiUrl,
        tenant: tenant,
        language: currentLanguage,
        camelcaseKeysOptions: {
          exclude: [/^[a-z]{2}-[A-Z]{2}$/, 'TermsAndConditions_Url', 'PrivacyPolicy_Url', 'Benefit_Icon1', 'Benefit_Icon2', 'Benefit_Icon3']
        },
        children: children
      })
    })
  });
};
exports.ApiProvider = ApiProvider;
//# sourceMappingURL=ApiProvider.js.map